@if (patients().length > 0) {
  <div class="alert alert-warning" role="alert">
    <h3>{{ 'patient.similar-patient-warning' | translate }}</h3>
    <ul class="list-unstyled mb-0">
      @for (patient of patients(); track patient.id) {
        <li class="border-top border-warning-subtle pt-2 mt-2">
          <dl class="row mb-1">
            <dt class="col-sm-3 mb-1">{{ 'patient.first-name' | translate }}</dt>
            <dd class="col-sm-9 mb-1">{{ patient.first_name }}</dd>
            <dt class="col-sm-3 mb-1">{{ 'patient.middle-name' | translate }}</dt>
            <dd class="col-sm-9 mb-1">{{ patient.middle_name ?? '-' }}</dd>
            <dt class="col-sm-3 mb-1">
              {{ 'patient.last-name' | translate }}
            </dt>
            <dd class="col-sm-9 mb-1">{{ patient.last_name }}</dd>
            <dt class="col-sm-3 mb-1">{{ 'patient.date-of-birth' | translate }}</dt>
            <dd class="col-sm-9 mb-1">
              {{ patient.date_of_birth | localDateFormat }}
            </dd>
            <dt class="col-sm-3 mb-1">{{ 'common.city' | translate }}</dt>
            <dd class="col-sm-9 mb-1">{{ patient.city }}</dd>
            <dt class="col-sm-3 mb-1">{{ 'common.email' | translate }}</dt>
            <dd class="col-sm-9 mb-1">{{ patient.email }}</dd>
            <dt class="col-sm-3 mb-1">{{ 'patient.mobile' | translate }}</dt>
            <dd class="col-sm-9 mb-1">{{ patient.mobile }}</dd>
          </dl>
          <a [routerLink]="['/patients', patient.id]" class="btn btn-primary">
            {{ 'navigation.patients.details' | translate }}
          </a>
        </li>
      }
    </ul>
  </div>
}
